import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import { PDFModule } from "app/services/pdf/pdf.module";
import { RegisterService } from "app/services/register/register.service";
import { HttpClientModule } from '@angular/common/http';
import { RetrieveService } from "app/services/register/retrieve.service";
import { RestrieveCookieService } from "app/services/register/restrieve.cookie.services";

@NgModule({
  imports: [
    CommonModule,
    PDFModule,
    HttpClientModule
  ],
  providers: [RegisterService,RetrieveService,RestrieveCookieService],
  declarations: []
})
export class ServiceModule { }



// WEBPACK FOOTER //
// ./src/app/services/service.module.ts